import { MARQUEE_ITEMS } from "@/lib/site";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-gold/15 bg-[#0D0D10] py-5" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-sm sm:text-base tracking-[0.22em] uppercase text-zinc-400 px-7">{item}</span>
            <svg width="10" height="10" viewBox="0 0 10 10" className="text-gold shrink-0">
              <path d="M5 0 L6.4 3.6 L10 5 L6.4 6.4 L5 10 L3.6 6.4 L0 5 L3.6 3.6 Z" fill="currentColor" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}
